export const LANGS = [
  { code: "es", label: "ES" },
  { code: "pt", label: "PT" },
  { code: "en", label: "EN" },
];

export const TRANSLATIONS = {
  es: {
    badge: "Imagen ilustrativa",
    nav: {
      inicio: "Inicio",
      habitaciones: "Habitaciones",
      servicios: "Servicios",
      galeria: "Galería",
      federacion: "Descubrí Federación",
      ubicacion: "Ubicación",
      contacto: "Contacto",
      reservar: "Reservar por WhatsApp",
      menuAbrir: "Abrir menú",
      menuCerrar: "Cerrar menú",
    },
    intro: {
      tagline: "Un lugar para descansar y disfrutar",
      ingresar: "Ingresar al sitio",
      aria: "Bienvenida a Hotel Federasol",
    },
    hero: {
      eyebrow: "Bienvenidos a Federación",
      lines: ["Tu lugar para", "descansar", "y disfrutar"],
      desc: "Descubrí Hotel Federasol, un espacio pensado para descansar, relajarte y disfrutar de una estadía inolvidable en Federación, Entre Ríos.",
      ctaWhats: "Consultar disponibilidad",
      ctaRooms: "Conocé nuestras habitaciones",
      trust: "Recepción 24 h · Desayuno incluido · A metros de las termas",
      scroll: "Deslizá",
    },
    marquee: [
      "Aguas termales",
      "Descanso",
      "Naturaleza",
      "Desayuno incluido",
      "Recepción 24 horas",
      "Federación, Entre Ríos",
    ],
    featured: [
      { t: "Desayuno incluido", d: "Empezá cada mañana con un rico desayuno." },
      { t: "Recepción 24 horas", d: "Estamos disponibles para ayudarte durante tu estadía." },
      { t: "Habitaciones confortables", d: "Todo lo necesario para disfrutar de un buen descanso." },
      { t: "Excelente ubicación", d: "Disfrutá de Federación y sus atractivos." },
    ],
    services: {
      eyebrow: "Servicios",
      title: "Todo lo que necesita tu estadía",
      subtitle: "Atención cálida y detalles pensados para que solo te ocupes de descansar.",
      items: [
        { t: "Wi-Fi", d: "Conectividad en todo el hotel." },
        { t: "Servicio de limpieza", d: "Tus habitaciones y las áreas comunes, siempre cuidadas." },
        { t: "Cambio de toallas y toallones", d: "Para tu comodidad durante la estadía." },
        { t: "Estacionamiento", d: "Consultalo al llegar.", note: "Sujeto a disponibilidad" },
        { t: "Habitaciones libres de humo", d: "Ambientes sanos para todos nuestros huéspedes." },
        { t: "Batas para termas", d: "Pedila en recepción.", note: "Con cargo adicional" },
        { t: "Aire acondicionado", d: "Frescura en verano y clima perfecto todo el año." },
        { t: "Calefacción", d: "Calidez en las noches de Entre Ríos." },
        { t: "No se admiten mascotas", d: "Agradecemos tu comprensión." },
      ],
    },
    rooms: {
      eyebrow: "Habitaciones",
      title: "Comodidad para tu estadía",
      subtitle: "Descansá en un ambiente cálido y confortable, ideal para disfrutar de unos días de tranquilidad en Federación.",
      desc: "Cálida y confortable, con todo lo necesario para un buen descanso.",
      cap: (n) => `Hasta ${n} huéspedes`,
      amenitiesTitle: "Todas las habitaciones incluyen",
      consult: "Consultar disponibilidad",
      noteText: "¿Ya sabés qué necesitás? Te asesoramos personalmente.",
      noteCta: "Escribinos por WhatsApp",
      items: [
        { n: "Doble individual", cap: 2 },
        { n: "Doble matrimonial", cap: 2 },
        { n: "Triple individual", cap: 3 },
        { n: "Triple matrimonial + somier", cap: 3 },
        { n: "Cuádruple matrimonial + cucheta", cap: 4 },
        { n: "Quíntuple matrimonial + cucheta + somier", cap: 5 },
      ],
      amenities: ["Ropa blanca", "Smart TV", "Aire acondicionado", "Baño privado", "Servicio diario de mucama"],
    },
    gallery: {
      eyebrow: "Galería",
      title: "Conocé nuestro hotel",
      subtitle: "Cada rincón está pensado para que disfrutes de tu estadía.",
      labels: ["Fachada del hotel", "Patio central", "Desayuno en salón", "Juegos de agua", "Pasillos rosados", "Aguas termales"],
      prev: "Foto anterior",
      next: "Foto siguiente",
      close: "Cerrar visor",
      counter: (a, b) => `${a} / ${b}`,
    },
    testimonials: {
      eyebrow: "Reseñas",
      title: "Lo que dicen nuestros huéspedes",
      subtitle: "Reseñas públicas de huéspedes que nos eligieron.",
      guestName: "Huésped de Google",
      seeAll: "Ver todas las reseñas en Google",
    },
    tourism: {
      eyebrow: "Turismo",
      title: "Descubrí Federación y sus Termas",
      subtitle: "Federación es uno de los destinos termales más reconocidos de Argentina. Un lugar ideal para descansar, disfrutar de sus aguas termales, conectar con la naturaleza y vivir momentos inolvidables.",
      cards: [
        { t: "Parque Termal de Federación", d: "Las piletas de aguas termales son el corazón de la ciudad: un espacio para relajarse, descansar y disfrutar del famoso complejo termal a puro bienestar." },
        { t: "Parque Acuático de Federación", d: "Diversión para toda la familia: juegos acuáticos y actividades para grandes y chicos que buscan disfrutar del agua." },
        { t: "Lago Salto Grande", d: "Paisajes únicos y actividades al aire libre en un entorno natural ideal para disfrutar con calma." },
        { t: "Costanera de Federación", d: "Un paseo costero perfecto para caminar, relajarse y disfrutar del paisaje a la hora del atardecer." },
        { t: "Gastronomía local", d: "Descubrí los restaurantes y sabores regionales de Federación: una propuesta culinaria para cada momento del día." },
        { t: "Actividades al aire libre", d: "Caminatas, paseos en bici y experiencias en la naturaleza para conectar con la ciudad y su paisaje." },
      ],
      benefits: {
        eyebrow: "Bienestar",
        title: "Beneficios de las aguas termales",
        text: "Sumergite en las termas y dale a vos el mimo que te merecés.",
        items: ["Relax y desconexión", "Agradable sensación de bienestar físico", "Alivio de la tensión cotidiana", "Descanso profundo"],
        disclaimer: "Información orientativa: los efectos del agua termal pueden variar de persona a persona.",
      },
    },
    thermal: {
      eyebrow: "Termas de Federación",
      title: "Relajate en las Termas de Federación",
      desc: "Disfrutá de una experiencia de descanso y bienestar en uno de los destinos termales más elegidos del país.",
      cta: "Consultá tu estadía",
      note: "El acceso al Parque Termal se abona aparte, según las tarifas del complejo.",
    },
    location: {
      eyebrow: "Ubicación",
      title: "Estamos en Federación",
      subtitle: "Una ubicación estratégica para disfrutar de la ciudad, sus termas y el paisaje de Entre Ríos.",
      phone: "Teléfono",
      whatsapp: "Móvil / WhatsApp",
      email: "Correo",
      howTo: "Cómo llegar",
      waBtn: "WhatsApp",
      distancesTitle: "Ubicación estratégica",
      welcome: "Hotel Federasol es un lugar acogedor y familiar, una opción perfecta para venir a descansar y disfrutar de nuestra ciudad.",
      distances: [
        { l: "Terminal de ómnibus", v: "100 m" },
        { l: "Centro comercial principal", v: "200 m" },
        { l: "Circuito aeróbico costero", v: "100 m" },
        { l: "Río Uruguay", v: "Al lado" },
        { l: "Entrada principal del Parque Termal", v: "150 m" },
        { l: "Parque Acuático", v: "150 m" },
      ],
    },
    contact: {
      eyebrow: "Contacto",
      title: "Escribinos, estamos para ayudarte",
      text: "Si preferís consultarnos por correo, dejanos tu mensaje y te respondemos a la brevedad. Para respuestas inmediatas, WhatsApp es el camino más rápido.",
      waBtn: "Consultar por WhatsApp",
      labels: {
        name: "Nombre y apellido",
        email: "Correo electrónico",
        phone: "Teléfono",
        guests: "Huéspedes",
        checkin: "Fecha de entrada",
        checkout: "Fecha de salida",
        message: "Mensaje",
      },
      optional: "(opcional)",
      choose: "Elegir",
      guestsOption: (n) => (n <= 5 ? `${n} ${n === 1 ? "huésped" : "huéspedes"}` : "6 o más"),
      ph: {
        name: "María González",
        email: "maria@email.com",
        message: "Contanos sobre tu estadía: fechas, cantidad de personas, lo que necesites.",
      },
      errors: {
        name: "Ingresá tu nombre y apellido.",
        email: "Ingresá un correo válido.",
        message: "Escribinos un mensaje para poder ayudarte.",
        checkout: "La salida debe ser posterior a la entrada.",
      },
      sending: "Enviando...",
      submit: "Enviar consulta",
      privacy: "Tus datos se utilizan únicamente para responder tu consulta y no se comparten con terceros.",
      successTitle: (name) => `¡Gracias, ${name}!`,
      successText: (email) => `Recibimos tu consulta y te vamos a responder a la brevedad a ${email}.`,
      successBtn: "Enviar otra consulta",
      toastOk: "¡Gracias! Tu consulta fue enviada. Te responderemos a la brevedad.",
      toastErr: "Mientras tanto, podés escribirnos directo por WhatsApp.",
    },
    footer: {
      tagline: "Tu lugar para descansar y disfrutar en Federación, Entre Ríos.",
      navTitle: "Navegación",
      contactTitle: "Contacto",
      copyright: "© 2026 Hotel Federasol. Todos los derechos reservados.",
      addressLine: "D'Angelo 475 · Federación · Entre Ríos · Argentina",
    },
    floating: {
      tooltip: "¡Consultá tu fecha por WhatsApp!",
      aria: "Consultar por WhatsApp",
    },
    wa: {
      default: "Hola! Estuve viendo la página web de Hotel Federasol y quisiera consultar disponibilidad para una estadía. Muchas gracias!",
      thermas: "Hola! Estuve viendo la página web de Hotel Federasol y quisiera consultar mi estadía para disfrutar de las Termas de Federación. Muchas gracias!",
      room: (r) => `Hola! Estuve viendo la página web de Hotel Federasol y quisiera consultar disponibilidad para la ${r}. Muchas gracias!`,
    },
  },

  pt: {
    badge: "Imagem ilustrativa",
    nav: {
      inicio: "Início",
      habitaciones: "Quartos",
      servicios: "Serviços",
      galeria: "Galeria",
      federacion: "Descubra Federación",
      ubicacion: "Localização",
      contacto: "Contato",
      reservar: "Reservar pelo WhatsApp",
      menuAbrir: "Abrir menu",
      menuCerrar: "Fechar menu",
    },
    intro: {
      tagline: "Um lugar para descansar e desfrutar",
      ingresar: "Entrar no site",
      aria: "Boas-vindas ao Hotel Federasol",
    },
    hero: {
      eyebrow: "Bem-vindos a Federación",
      lines: ["Seu lugar para", "descansar", "e desfrutar"],
      desc: "Descubra o Hotel Federasol, um espaço pensado para descansar, relaxar e aproveitar uma estadia inesquecível em Federación, Entre Ríos.",
      ctaWhats: "Consultar disponibilidade",
      ctaRooms: "Conheça nossos quartos",
      trust: "Recepção 24 h · Café da manhã incluído · A metros das termas",
      scroll: "Role",
    },
    marquee: [
      "Águas termais",
      "Descanso",
      "Natureza",
      "Café da manhã incluído",
      "Recepção 24 horas",
      "Federación, Entre Ríos",
    ],
    featured: [
      { t: "Café da manhã incluído", d: "Comece cada manhã com um delicioso café da manhã." },
      { t: "Recepção 24 horas", d: "Estamos disponíveis para ajudá-lo durante sua estadia." },
      { t: "Quartos confortáveis", d: "Tudo o que é necessário para uma boa noite de sono." },
      { t: "Excelente localização", d: "Aproveite Federación e seus atrativos." },
    ],
    services: {
      eyebrow: "Serviços",
      title: "Tudo o que a sua estadia precisa",
      subtitle: "Atenção acolhedora e detalhes pensados para você se preocupar apenas em descansar.",
      items: [
        { t: "Wi-Fi", d: "Conectividade em todo o hotel." },
        { t: "Serviço de limpeza", d: "Seus quartos e as áreas comuns, sempre bem cuidados." },
        { t: "Troca de toalhas", d: "Para seu conforto durante a estadia." },
        { t: "Estacionamento", d: "Consulte na chegada.", note: "Sujeito a disponibilidade" },
        { t: "Quartos para não fumantes", d: "Ambientes saudáveis para todos os nossos hóspedes." },
        { t: "Roupões para as termas", d: "Solicite na recepção.", note: "Custo adicional" },
        { t: "Ar-condicionado", d: "Frescor no verão e clima perfeito o ano todo." },
        { t: "Aquecimento", d: "Calor nas noites de Entre Ríos." },
        { t: "Não aceitamos animais de estimação", d: "Agradecemos sua compreensão." },
      ],
    },
    rooms: {
      eyebrow: "Quartos",
      title: "Conforto para a sua estadia",
      subtitle: "Durma em um ambiente acolhedor e confortável, ideal para aproveitar dias de tranquilidade em Federación.",
      desc: "Aconchegante e confortável, com tudo o que é necessário para um bom descanso.",
      cap: (n) => `Até ${n} hóspedes`,
      amenitiesTitle: "Todos os quartos incluem",
      consult: "Consultar disponibilidade",
      noteText: "Já sabe o que precisa? Podemos ajudá-lo pessoalmente.",
      noteCta: "Escreva para nós pelo WhatsApp",
      items: [
        { n: "Duplo individual", cap: 2 },
        { n: "Duplo casal", cap: 2 },
        { n: "Triplo individual", cap: 3 },
        { n: "Triplo casal + cama box", cap: 3 },
        { n: "Quádruplo casal + beliche", cap: 4 },
        { n: "Quíntuplo casal + beliche + cama box", cap: 5 },
      ],
      amenities: ["Roupas de cama", "Smart TV", "Ar-condicionado", "Banheiro privativo", "Serviço diário de arrumação"],
    },
    gallery: {
      eyebrow: "Galeria",
      title: "Conheça nosso hotel",
      subtitle: "Cada cantinho é pensado para você aproveitar sua estadia.",
      labels: ["Fachada do hotel", "Pátio central", "Salão de café da manhã", "Brinquedos aquáticos", "Corredores rosados", "Águas termais"],
      prev: "Foto anterior",
      next: "Próxima foto",
      close: "Fechar visualizador",
      counter: (a, b) => `${a} / ${b}`,
    },
    testimonials: {
      eyebrow: "Avaliações",
      title: "O que dizem nossos hóspedes",
      subtitle: "Avaliações públicas de hóspedes que nos escolheram.",
      guestName: "Hóspede do Google",
      seeAll: "Ver todas as avaliações no Google",
    },
    tourism: {
      eyebrow: "Turismo",
      title: "Descubra Federación e suas Termas",
      subtitle: "Federación é um dos destinos termais mais reconhecidos da Argentina. Um lugar ideal para descansar, desfrutar de suas águas termais, conectar-se com a natureza e viver momentos inesquecíveis.",
      cards: [
        { t: "Parque Termal de Federación", d: "As piscinas de águas termais são o coração da cidade: um espaço para relaxar, descansar e aproveitar o famoso complexo termal em pleno bem-estar." },
        { t: "Parque Aquático de Federación", d: "Diversão para toda a família: jogos aquáticos e atividades para grandes e pequenos que querem aproveitar a água." },
        { t: "Lago Salto Grande", d: "Paisagens únicas e atividades ao ar livre em um ambiente natural ideal para curtir com calma." },
        { t: "Costanera de Federación", d: "Um passeio à beira-d'água perfeito para caminhar, relaxar e apreciar a paisagem ao pôr do sol." },
        { t: "Gastronomia local", d: "Descubra os restaurantes e sabores regionais de Federación: uma proposta culinária para cada momento do dia." },
        { t: "Atividades ao ar livre", d: "Caminhadas, passeios de bicicleta e experiências na natureza para se conectar com a cidade e sua paisagem." },
      ],
      benefits: {
        eyebrow: "Bem-estar",
        title: "Benefícios das águas termais",
        text: "Mergulhe nas termas e cuide de você.",
        items: ["Relaxamento e desconexão", "Agradável sensação de bem-estar físico", "Alívio da tensão do dia a dia", "Descanso profundo"],
        disclaimer: "Informação orientativa: os efeitos da água termal podem variar de pessoa para pessoa.",
      },
    },
    thermal: {
      eyebrow: "Termas de Federación",
      title: "Relaxe-se nas Termas de Federación",
      desc: "Aproveite uma experiência de descanso e bem-estar em um dos destinos termais mais escolhidos do país.",
      cta: "Consulte sua estadia",
      note: "O acesso ao Parque Termal é pago à parte, conforme as tarifas do complexo.",
    },
    location: {
      eyebrow: "Localização",
      title: "Estamos em Federación",
      subtitle: "Uma localização estratégica para aproveitar a cidade, suas termas e a paisagem de Entre Ríos.",
      phone: "Telefone",
      whatsapp: "Celular / WhatsApp",
      email: "E-mail",
      howTo: "Como chegar",
      waBtn: "WhatsApp",
      distancesTitle: "Localização estratégica",
      welcome: "Hotel Federasol é um lugar acolhedor e familiar, uma opção perfeita para vir descansar e aproveitar nossa cidade.",
      distances: [
        { l: "Rodoviária", v: "100 m" },
        { l: "Centro comercial principal", v: "200 m" },
        { l: "Circuito aeróbico costeiro", v: "100 m" },
        { l: "Rio Uruguai", v: "Ao lado" },
        { l: "Entrada principal do Parque Termal", v: "150 m" },
        { l: "Parque Aquático", v: "150 m" },
      ],
    },
    contact: {
      eyebrow: "Contato",
      title: "Escreva para nós, estamos para ajudá-lo",
      text: "Se preferir nos consultar por e-mail, deixe sua mensagem e responderemos o quanto antes. Para respostas imediatas, o WhatsApp é o caminho mais rápido.",
      waBtn: "Consultar pelo WhatsApp",
      labels: {
        name: "Nome e sobrenome",
        email: "E-mail",
        phone: "Telefone",
        guests: "Hóspedes",
        checkin: "Data de entrada",
        checkout: "Data de saída",
        message: "Mensagem",
      },
      optional: "(opcional)",
      choose: "Escolher",
      guestsOption: (n) => (n <= 5 ? `${n} ${n === 1 ? "hóspede" : "hóspedes"}` : "6 ou mais"),
      ph: {
        name: "Maria Silva",
        email: "maria@email.com",
        message: "Conte-nos sobre sua estadia: datas, número de pessoas, o que precisar.",
      },
      errors: {
        name: "Digite seu nome e sobrenome.",
        email: "Digite um e-mail válido.",
        message: "Escreva uma mensagem para que possamos ajudá-lo.",
        checkout: "A saída deve ser posterior à entrada.",
      },
      sending: "Enviando...",
      submit: "Enviar consulta",
      privacy: "Seus dados são utilizados apenas para responder à sua consulta e não são compartilhados com terceiros.",
      successTitle: (name) => `Obrigado, ${name}!`,
      successText: (email) => `Recebemos sua consulta e responderemos em breve para ${email}.`,
      successBtn: "Enviar outra consulta",
      toastOk: "Obrigado! Sua consulta foi enviada. Responderemos em breve.",
      toastErr: "Enquanto isso, você pode nos escrever direto pelo WhatsApp.",
    },
    footer: {
      tagline: "Seu lugar para descansar e desfrutar em Federación, Entre Ríos.",
      navTitle: "Navegação",
      contactTitle: "Contato",
      copyright: "© 2026 Hotel Federasol. Todos os direitos reservados.",
      addressLine: "D'Angelo 475 · Federación · Entre Ríos · Argentina",
    },
    floating: {
      tooltip: "Consulte sua data pelo WhatsApp!",
      aria: "Consultar pelo WhatsApp",
    },
    wa: {
      default: "Olá! Estive vendo o site do Hotel Federasol e gostaria de consultar a disponibilidade para uma estadia. Muito obrigado!",
      thermas: "Olá! Estive vendo o site do Hotel Federasol e gostaria de consultar minha estadia para aproveitar as Termas de Federación. Muito obrigado!",
      room: (r) => `Olá! Estive vendo o site do Hotel Federasol e gostaria de consultar a disponibilidade para o quarto ${r}. Muito obrigado!`,
    },
  },

  en: {
    badge: "Illustrative image",
    nav: {
      inicio: "Home",
      habitaciones: "Rooms",
      servicios: "Services",
      galeria: "Gallery",
      federacion: "Discover Federación",
      ubicacion: "Location",
      contacto: "Contact",
      reservar: "Book via WhatsApp",
      menuAbrir: "Open menu",
      menuCerrar: "Close menu",
    },
    intro: {
      tagline: "A place to rest and enjoy",
      ingresar: "Enter site",
      aria: "Welcome to Hotel Federasol",
    },
    hero: {
      eyebrow: "Welcome to Federación",
      lines: ["Your place to", "rest", "and enjoy"],
      desc: "Discover Hotel Federasol, a space designed to rest, relax and enjoy an unforgettable stay in Federación, Entre Ríos.",
      ctaWhats: "Check availability",
      ctaRooms: "Explore our rooms",
      trust: "24-hour front desk · Breakfast included · Steps from the thermal baths",
      scroll: "Scroll",
    },
    marquee: [
      "Thermal waters",
      "Rest",
      "Nature",
      "Breakfast included",
      "24-hour front desk",
      "Federación, Entre Ríos",
    ],
    featured: [
      { t: "Breakfast included", d: "Start every morning with a delicious breakfast." },
      { t: "24-hour front desk", d: "We're here to help throughout your stay." },
      { t: "Comfortable rooms", d: "Everything you need to enjoy a good night's sleep." },
      { t: "Excellent location", d: "Enjoy Federación and its attractions." },
    ],
    services: {
      eyebrow: "Services",
      title: "Everything your stay needs",
      subtitle: "Warm attention and thoughtful details so you can focus on resting.",
      items: [
        { t: "Wi-Fi", d: "Connectivity throughout the hotel." },
        { t: "Housekeeping", d: "Your room and common areas, always well kept." },
        { t: "Towel change", d: "For your comfort during your stay." },
        { t: "Parking", d: "Ask about it on arrival.", note: "Subject to availability" },
        { t: "Smoke-free rooms", d: "Healthy spaces for all our guests." },
        { t: "Thermal bathrobes", d: "Ask at the front desk.", note: "Additional charge" },
        { t: "Air conditioning", d: "Cool in summer, perfect all year round." },
        { t: "Heating", d: "Warmth on Entre Ríos nights." },
        { t: "Pets not allowed", d: "Thank you for understanding." },
      ],
    },
    rooms: {
      eyebrow: "Rooms",
      title: "Comfort for your stay",
      subtitle: "Rest in a warm, comfortable environment, ideal for enjoying a few peaceful days in Federación.",
      desc: "Cozy and comfortable, with everything you need for a good night's rest.",
      cap: (n) => `Up to ${n} guests`,
      amenitiesTitle: "Every room includes",
      consult: "Check availability",
      noteText: "Know what you need? We'll advise you personally.",
      noteCta: "Message us on WhatsApp",
      items: [
        { n: "Twin Double Room", cap: 2 },
        { n: "Double Room", cap: 2 },
        { n: "Twin Triple Room", cap: 3 },
        { n: "Double Triple Room + extra bed", cap: 3 },
        { n: "Quadruple Room + bunk bed", cap: 4 },
        { n: "Quintuple Room + bunk bed + extra bed", cap: 5 },
      ],
      amenities: ["Bed linens", "Smart TV", "Air conditioning", "Private bathroom", "Daily housekeeping"],
    },
    gallery: {
      eyebrow: "Gallery",
      title: "Get to know our hotel",
      subtitle: "Every corner is designed so you enjoy your stay.",
      labels: ["Hotel facade", "Central courtyard", "Breakfast room", "Water play", "Pink hallways", "Thermal waters"],
      prev: "Previous photo",
      next: "Next photo",
      close: "Close viewer",
      counter: (a, b) => `${a} / ${b}`,
    },
    testimonials: {
      eyebrow: "Reviews",
      title: "What our guests say",
      subtitle: "Public reviews from guests who stayed with us.",
      guestName: "Google guest",
      seeAll: "See all reviews on Google",
    },
    tourism: {
      eyebrow: "Tourism",
      title: "Discover Federación and its Thermal Baths",
      subtitle: "Federación is one of Argentina's best-known thermal destinations. An ideal place to rest, enjoy its thermal waters, connect with nature and live unforgettable moments.",
      cards: [
        { t: "Federación Thermal Park", d: "The thermal pools are the heart of the city: a space to relax, unwind and enjoy the famous thermal complex in total wellbeing." },
        { t: "Federación Water Park", d: "Fun for the whole family: water play and activities for kids and grown-ups who love the water." },
        { t: "Salto Grande Lake", d: "Unique landscapes and outdoor activities in a natural setting perfect for taking it easy." },
        { t: "Federación Waterfront", d: "A perfect coastal promenade for walking, relaxing and enjoying the scenery at sunset." },
        { t: "Local cuisine", d: "Discover Federación's restaurants and regional flavors: a culinary offering for every moment of the day." },
        { t: "Outdoor activities", d: "Walks, bike rides and nature experiences to connect with the city and its landscape." },
      ],
      benefits: {
        eyebrow: "Wellbeing",
        title: "Benefits of thermal waters",
        text: "Slip into the thermal baths and treat yourself.",
        items: ["Relaxation and disconnection", "A pleasant feeling of physical wellbeing", "Relief from everyday tension", "Deep rest"],
        disclaimer: "General information: the effects of thermal water may vary from person to person.",
      },
    },
    thermal: {
      eyebrow: "Federación Thermal Baths",
      title: "Relax at the Federación Thermal Baths",
      desc: "Enjoy an experience of rest and wellbeing in one of the country's favorite thermal destinations.",
      cta: "Ask about your stay",
      note: "Access to the Thermal Park is paid separately, according to the complex's rates.",
    },
    location: {
      eyebrow: "Location",
      title: "We're in Federación",
      subtitle: "A strategic location to enjoy the town, its thermal baths and the Entre Ríos landscape.",
      phone: "Phone",
      whatsapp: "Mobile / WhatsApp",
      email: "Email",
      howTo: "Directions",
      waBtn: "WhatsApp",
      distancesTitle: "Strategic location",
      welcome: "Hotel Federasol is a warm, family-friendly place — the perfect option to come and rest and enjoy our town.",
      distances: [
        { l: "Bus terminal", v: "100 m" },
        { l: "Main shopping area", v: "200 m" },
        { l: "Coastal fitness trail", v: "100 m" },
        { l: "Uruguay River", v: "Right next door" },
        { l: "Main entrance of the Thermal Park", v: "150 m" },
        { l: "Water Park", v: "150 m" },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Write to us — we're here to help",
      text: "If you'd rather reach us by email, leave your message and we'll reply shortly. For immediate answers, WhatsApp is the fastest way.",
      waBtn: "Ask via WhatsApp",
      labels: {
        name: "Full name",
        email: "Email",
        phone: "Phone",
        guests: "Guests",
        checkin: "Check-in date",
        checkout: "Check-out date",
        message: "Message",
      },
      optional: "(optional)",
      choose: "Choose",
      guestsOption: (n) => (n <= 5 ? `${n} ${n === 1 ? "guest" : "guests"}` : "6 or more"),
      ph: {
        name: "Mary Smith",
        email: "mary@email.com",
        message: "Tell us about your stay: dates, number of people, whatever you need.",
      },
      errors: {
        name: "Please enter your full name.",
        email: "Please enter a valid email.",
        message: "Please write us a message so we can help.",
        checkout: "Check-out must be after check-in.",
      },
      sending: "Sending...",
      submit: "Send inquiry",
      privacy: "Your details are used only to answer your inquiry and are never shared with third parties.",
      successTitle: (name) => `Thank you, ${name}!`,
      successText: (email) => `We received your inquiry and will reply to ${email} shortly.`,
      successBtn: "Send another inquiry",
      toastOk: "Thank you! Your inquiry was sent. We'll get back to you shortly.",
      toastErr: "In the meantime, you can message us directly on WhatsApp.",
    },
    footer: {
      tagline: "Your place to rest and enjoy in Federación, Entre Ríos.",
      navTitle: "Navigation",
      contactTitle: "Contact",
      copyright: "© 2026 Hotel Federasol. All rights reserved.",
      addressLine: "D'Angelo 475 · Federación · Entre Ríos · Argentina",
    },
    floating: {
      tooltip: "Ask for your dates on WhatsApp!",
      aria: "Chat on WhatsApp",
    },
    wa: {
      default: "Hi! I was browsing the Hotel Federasol website and would like to ask about availability for a stay. Thank you!",
      thermas: "Hi! I was browsing the Hotel Federasol website and would like to ask about my stay to enjoy the Federación Thermal Baths. Thank you!",
      room: (r) => `Hi! I was browsing the Hotel Federasol website and would like to ask about availability for the ${r}. Thank you!`,
    },
  },
};
